import React, { useState, useEffect } from "react";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import editIcon from "../../asessts/Images/edit_pen_icon.svg";
import toast from "react-hot-toast";
import eyeIcon from "../../asessts/Images/eye_icon.svg";
import eyeSlashIcon from "../../asessts/Images/eye_close.svg";
import TimesIcon from "../../asessts/Images/times_icon.svg";

import Api from "../../services/Api";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../components/loader/Loading";
import { setAdminData } from "../../redux/slices/AdminSlice";
import { fetchAndSetAdminData } from "../../services/AdminService";
import { ShimmerThumbnail } from "react-shimmer-effects";

function Setting() {
  const [openPasswordPopup, setOpenPasswordPopup] = useState(false);
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [formValues, setFormValues] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [profileForm, setProfileForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    image: null,
    oldImage: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordLoading, setIsPasswordLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const dispatch = useDispatch();
  const adminData = useSelector((state) => state.adminSlice.adminData);

  useEffect(() => {
    if (!adminData.firstName) {
      const token = localStorage.getItem("careToken");
      if (token) {
        fetchAndSetAdminData(token, dispatch);
      }
    } else {
      setProfileForm({
        firstName: adminData.firstName,
        lastName: adminData.lastName,
        email: adminData.email,
        oldImage: adminData.image,
      });
      if (adminData.image) {
        setImagePreview(adminData.image);
      }
    }
  }, [adminData, dispatch]);
  //fetchAdminData();

  const fetchAdminData = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("careToken");
      if (!token) {
        toast.error("User not authenticated");
        return;
      }

      const response = await Api.getAdminInfo(token);

      if (response.data.status) {
        const adminData = response.data.data;
        setProfileForm({
          firstName: adminData.firstName,
          lastName: adminData.lastName,
          email: adminData.email,
          oldImage: adminData.image,
        });
        if (adminData.image) {
          setImagePreview(adminData.image);
        }
        dispatch(
          setAdminData({
            firstName: adminData.firstName,
            lastName: adminData.lastName,
            email: adminData.email,
            image: adminData.image,
          })
        );
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to fetch admin data"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordChange = () => {
    setOpenPasswordPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPasswordPopup(false);
    setFormValues({
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    });
    setErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  const handleProfileInputChange = (e) => {
    const { name, value } = e.target;
    setProfileForm({
      ...profileForm,
      [name]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileForm({
        ...profileForm,
        image: file,
        oldImage: profileForm.oldImage,
      });

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleShowPassword = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formValues.currentPassword) {
      newErrors.currentPassword = "Current password is required";
    }

    if (!formValues.newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (formValues.newPassword.length < 8) {
      newErrors.newPassword = "Password must be at least 8 characters";
    }

    if (!formValues.confirmNewPassword) {
      newErrors.confirmNewPassword = "Please confirm your new password";
    } else if (formValues.newPassword !== formValues.confirmNewPassword) {
      newErrors.confirmNewPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateProfileForm = () => {
    const newErrors = {};

    if (!profileForm.firstName) {
      newErrors.firstName = "First name is required";
    }

    if (!profileForm.lastName) {
      newErrors.lastName = "Last name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSavePassword = async () => {
    if (!validateForm()) return;

    const payload = {
      currentPassword: formValues.currentPassword,
      newPassword: formValues.newPassword,
      confirmPassword: formValues.confirmNewPassword,
    };

    const token = localStorage.getItem("careToken");

    if (!token) {
      toast.error("User not authenticated");
      return;
    }

    setIsPasswordLoading(true);

    try {
      const response = await Api.changeProviderPassword(payload, token);

      if (response.status) {
        toast.success(response.message || "Password changed successfully");
        handleClosePopup();
      } else {
        toast.error(response.message || "Failed to change password");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong while changing password"
      );
    } finally {
      setIsPasswordLoading(false);
    }
  };

  const handleSaveProfile = async () => {
    if (!validateProfileForm()) return;

    const token = localStorage.getItem("careToken");
    if (!token) {
      toast.error("User not authenticated");
      return;
    }

    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("firstName", profileForm.firstName);
      formData.append("lastName", profileForm.lastName);
      formData.append("oldImage", profileForm.oldImage);
      if (profileForm.image) {
        formData.append("newAdminImage", profileForm.image);
      }
      const response = await Api.updateAdminInfo(formData, token);

      if (response.data.status) {
        toast.success(response.data.message || "Profile updated successfully");
        const updatedAdminData = {
          firstName: profileForm.firstName,
          lastName: profileForm.lastName,
          email: profileForm.email,
          image: imagePreview,
        };
        dispatch(setAdminData(updatedAdminData));
        //fetchAdminData();
      } else {
        toast.error(response.data.message || "Failed to update profile");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong while updating profile"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header title={"Settings"} />
        {isLoading ? (
          <Loading />
        ) : (
          <div className="setting-main new-profile-main">
            <div className="setting-details">
              <h2>Basic Details</h2>
              <p>
                view & manage your basic profile details for the admin account
              </p>
              <div className="basic-detail">
                <div className="profile-upload">
                  {/* <div className="profile-img">
                  <div className="input-file">
                    <input type="file" onChange={handleImageChange} />
                    {imagePreview ? (
                      <img
                        src={imagePreview}
                        alt="Profile"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      <img src={editIcon} alt="" />
                    )}
                  </div>
                </div> */}
                  <div className="profile-img">
                    {imagePreview ? (
                      <>
                        <img
                          src={imagePreview}
                          alt="Profile"
                          className="main-profile-img"
                        />
                        <div className="input-file">
                          <input type="file" onChange={handleImageChange} />
                          <img src={editIcon} alt="Edit Icon" />
                        </div>
                      </>
                    ) : (
                      <ShimmerThumbnail height={200} rounded />
                    )}
                  </div>

                  <label>Update Picture</label>
                </div>
                <div className="profile-details">
                  <div className="input-group">
                    <div className="input-field">
                      <label>First Name</label>
                      <input
                        type="text"
                        placeholder="Henry"
                        name="firstName"
                        value={profileForm.firstName}
                        onChange={handleProfileInputChange}
                      />
                      {errors.firstName && (
                        <span className="error-message">
                          {errors.firstName}
                        </span>
                      )}
                    </div>
                    <div className="input-field">
                      <label>Last Name</label>
                      <input
                        type="text"
                        placeholder="Estward"
                        name="lastName"
                        value={profileForm.lastName}
                        onChange={handleProfileInputChange}
                      />
                      {errors.lastName && (
                        <span className="error-message">{errors.lastName}</span>
                      )}
                    </div>
                  </div>
                  <div className="input-group">
                    <div className="input-field">
                      <label>Email</label>
                      <input
                        type="email"
                        placeholder="abcde@gmail.com"
                        value={profileForm.email}
                        readOnly
                      />
                    </div>
                    <div className="input-field">
                      <label>Password</label>
                      <div className="password-change">
                        <input
                          type="password"
                          placeholder="xxxxxxxxxxxxx"
                          readOnly
                        />
                        <button onClick={handlePasswordChange}>change</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="save-btn">
                <button onClick={handleSaveProfile} disabled={isLoading}>
                  {isLoading ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Change Password Popup */}
      {openPasswordPopup && (
        <>
          <div
            className={`change-password-main ${
              openPasswordPopup ? "change-active" : ""
            }`}
          >
            <div className="change-head">
              <h2>Change Password</h2>
              <button onClick={handleClosePopup}>
                <img src={TimesIcon} alt="Close" />
              </button>
            </div>
            <div className="input-field">
              <label>Current Password</label>
              <div className="password">
                <input
                  name="currentPassword"
                  type={showPassword.current ? "text" : "password"}
                  placeholder="**********"
                  value={formValues.currentPassword}
                  onChange={handleInputChange}
                />
                <span onClick={() => handleShowPassword("current")}>
                  <img
                    src={showPassword.current ? eyeIcon : eyeSlashIcon}
                    alt="Toggle visibility"
                  />
                </span>
              </div>
              {errors.currentPassword && (
                <span
                  className="error-message"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {errors.currentPassword}
                </span>
              )}
            </div>
            <div className="input-field">
              <label>New Password</label>
              <div className="password">
                <input
                  name="newPassword"
                  type={showPassword.new ? "text" : "password"}
                  placeholder="**********"
                  value={formValues.newPassword}
                  onChange={handleInputChange}
                />
                <span onClick={() => handleShowPassword("new")}>
                  <img
                    src={showPassword.new ? eyeIcon : eyeSlashIcon}
                    alt="Toggle visibility"
                  />
                </span>
              </div>
              {errors.newPassword && (
                <span
                  className="error-message"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {errors.newPassword}
                </span>
              )}
            </div>
            <div className="input-field">
              <label>Confirm New Password</label>
              <div className="password">
                <input
                  name="confirmNewPassword"
                  type={showPassword.confirm ? "text" : "password"}
                  placeholder="**********"
                  value={formValues.confirmNewPassword}
                  onChange={handleInputChange}
                />
                <span onClick={() => handleShowPassword("confirm")}>
                  <img
                    src={showPassword.confirm ? eyeIcon : eyeSlashIcon}
                    alt="Toggle visibility"
                  />
                </span>
              </div>
              {errors.confirmNewPassword && (
                <span
                  className="error-message"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginTop: "5px",
                    display: "block",
                  }}
                >
                  {errors.confirmNewPassword}
                </span>
              )}
            </div>
            <div className="password-btn">
              <button className="cancle-btn" onClick={handleClosePopup}>
                Cancel
              </button>
              <button
                className="Save-btn"
                onClick={handleSavePassword}
                disabled={isPasswordLoading}
                style={{ opacity: isLoading ? 0.7 : 1 }}
              >
                {isPasswordLoading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
          <div
            className="overlay"
            onClick={handleClosePopup}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0, 0, 0, 0.5)",
              zIndex: 1110,
            }}
          ></div>
        </>
      )}
    </div>
  );
}

export default Setting;
